import Constant from '@/const';
import axios from 'axios';

const getAllOperationMarking = async idEMR => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/document/medical-treatment/all/${idEMR}`),
    );
    return response.data.data;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getAllOperationMarking;
